import { Form, redirect, useOutletContext, type ActionFunction } from "react-router";

import { httpSuccessToast } from "@/utils";
import { Api, type Types } from "@/services";
import { JOB_STATUS, JOB_TYPE } from "@/helpers";

import { DashboardFormPageWrapper, FormRow, FormRowSelect, SubmitBtn } from "@/components";

export const addJobAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const payload = Object.fromEntries(formData) as unknown as Types.Request.AddJob;

  const resp = await Api.AddJob(payload);
  httpSuccessToast(resp, "Job added successfully");
  return redirect("all-jobs");
};

const AddJob = () => {
  const { user } = useOutletContext<Types.Response.CurrentUser>();

  return (
    <DashboardFormPageWrapper>
      <Form className="form" method="POST">
        <h4 className="form-title">Add Job</h4>

        <div className="form-center">
          <FormRow name="position" />
          <FormRow name="company" />
          <FormRow labelText="job location" name="jobLocation" defaultValue={user.location} />

          <FormRowSelect labelText="job status" name="jobStatus" list={Object.values(JOB_STATUS)} defaultValue={JOB_STATUS.PENDING} />
          <FormRowSelect labelText="job type" name="jobType" list={Object.values(JOB_TYPE)} defaultValue={JOB_TYPE.FULL_TIME} />
          <SubmitBtn formBtn />
        </div>
      </Form>
    </DashboardFormPageWrapper>
  );
};

export default AddJob;
